import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import List from "@/Pages/Reports/Expenses/List.vue";
let Staff = class Staff extends Vue {
    user;
    dates;
    branchesId;
    extendQuery = { staffId: { $ne: null } };
};
__decorate([
    Prop(Array)
], Staff.prototype, "user", void 0);
__decorate([
    Prop(Object)
], Staff.prototype, "dates", void 0);
__decorate([
    Prop(Array)
], Staff.prototype, "branchesId", void 0);
Staff = __decorate([
    Component({
        components: { List },
    })
], Staff);
export default Staff;
